import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';
import { HttpHeaders } from '@angular/common/http';
import { PatientAppointment } from '../../../interfaces/patient-services/patient-appointment';
import { Visit } from '../../../interfaces/ehr/visit';

@Injectable()
export class PatientAppointmentApi {
  private readonly apiController: string = 'PatAppointment/';

  constructor(private api: HttpService) { }

  list(url: string, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    //header.append('Content-Type', 'applications/json');
    //headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    //header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  getPatientBookedPastAppts(url: string, options?: any): Observable<any> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
  
    return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
  }

  

  getSlots(url: string, options?: any): Observable<any> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,header);
  }

  getById(url: string, options?: any): Observable<PatientAppointment> {
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.get(url,header);
  }

  add(url:string, data: PatientAppointment):Observable<PatientAppointment>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post(url, data, header);
  }
  addApptVisit(url:string, data: PatientAppointment):Observable<Visit>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post(url, data, header);
  }

  createAppointment(url:string, data: PatientAppointment):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post(url, data, header);
  }

  
  bulkUpdate(url:string, data: PatientAppointment):Observable<PatientAppointment>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.post(url, data, header);
  }

  update(url:string, data: PatientAppointment):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.put( url, data, header);
  }

  delete(url: string):Observable<any>{
    return this.api.delete(url);
  }
  cancelApt(url: string, data: any):Observable<any>{
    let header = new HttpHeaders();
    header.append('Content-Type', 'applications/json');
    header.append('Accept','application/vnd.ezovion.hateoas+json');
    return this.api.put( url,data, header);
    }
  searchList(url: string, data:any, options?: any): Observable<any[]> {
    const header = new HttpHeaders({"Accept":"application/vnd.ezovion.hateoas+json"});
    
    return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
  }
  patch(url: string, data): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/vnd.ezovion.hateoas+json'
    });

    return this.api.patch(url, data, { headers });
  }
  
}
